// src/helpers/save-profile.ts
import type { RegistrationData } from "../contexts/auth/types";
import { profileApi } from "../api/profile/profile";
import type { Profile } from "../api/profile/profile.types";

export async function saveProfile(data: RegistrationData): Promise<Profile> {
  const updateData: Record<string, unknown> = {
    first_name: data.firstName ?? null,
    last_name: data.lastName ?? null,
    company_name: data.company ?? null,
    email_address: data.email ?? null,
    mobile_number: data.phoneNumber ?? null,
    preferred_timezone: data.timezone ?? null,
    nickname: data.nickname ?? null,

    auth_provider: data.authProvider ?? null,
    registration_completed: data.registration_completed ?? null,
    onboarding_completed: data.onboarding_completed ?? null,
    registration_step: data.registration_step ?? null,

    biometrics_enabled: data.biometricsEnabled ?? null,
    biometrics_type: data.biometricType === 'unknown' ? 'passkey' : (data.biometricType ?? null),
    notification_method: data.notificationMethod ?? null,
    sms_consent: data.smsConsent ?? null,

    password: (data as any)?.password ?? undefined,
  };

  if ((data as any)?.pendingEmail) {
    delete updateData.email_address;
  }

  Object.keys(updateData).forEach((k) => {
    if (updateData[k] === undefined) delete updateData[k];
  });

  try {
    // IMPORTANT: return whatever your wrapper returns
    const res = await profileApi.updateMe(updateData);

    // support both shapes:
    // - res is the row
    // - res.profile is the row
    const row = ((res as any)?.profile ?? res) as Profile;

    return row;
  } catch (error) {
    console.error("[saveProfile] Error saving profile:", error);
    throw error;
  }
}
